import React from 'react'
import { Button as ActionButton, IconButton, makeStyles } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(0.5)
    },
    label: {
        textTransform: 'none'
    }
}))

export default function Button(props) {

    const { text, size, children, actionIcon, color, variant, onClick, ...other } = props
    const classes = useStyles();

    return (
        <ActionButton
            size={size || "large"}
            variant={variant || "outlined"}
            color={color || "primary"}
            onClick={onClick}
            {...other}
        >
            {children}
        </ActionButton>
    )
}
